module.exports = __webpack_public_path__ + "img/Fossil-Creek.cbca34a9.png";